// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__CCQab","loading-bar-spinner":"Spinner_loading-bar-spinner__AmAnV","spinnerIcon":"Spinner_spinnerIcon__rGmoM"};